import { Component, Input, inject } from '@angular/core';

import {
    CookieName,
    CookieService,
    MenuActionOrigin,
    MenuActionsService,
    MenuContentItem,
    MenuDisplayMode,
    MenuSection,
    Page,
    UtilsService,
} from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-nv-menu-item',
    templateUrl: 'newvisitor-page-menuitem.html',
})
export class NewVisitorPageMenuItemComponent {
    private menuActionsService = inject(MenuActionsService);
    private cookieService = inject(CookieService);

    @Input() item: MenuContentItem;

    MenuSection = MenuSection;
    private pageConfig = inject(Page);
    get useFastIconType(): boolean {
        return this.pageConfig.htmlSourceTypeReplace ? UtilsService.indexableTypeContainsKey(this.pageConfig.htmlSourceTypeReplace, 'login') : false;
    }

    processClick(event: Event, item: MenuContentItem) {
        this.cookieService.put(CookieName.NewVisitorPageOpted, '1');
        this.menuActionsService.processClick(event, item, MenuActionOrigin.Misc, false);
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
